import Box from "@mui/material/Box"; // ==============================================================

// ==============================================================
const Image = (props) => <Box component="img" {...props} />;

export default Image;
